import { useState, useEffect } from 'react';
import firebase from 'firebase';

const useEmpresa = () => {
    const [empresa, setEmpresa] = useState([]);

    useEffect(() => {
        (async () => {
            const snap = await firebase.database().ref('Empresa').once('value');
            if (snap.exists()) {
                let empresas = []
                let data = { label: 'Todas las empresas', value: 0, key:0 }
                empresas.push(data)
                snap.forEach(element => {
                    data = element.val();
                    data = { label: element.val().codigo_empresa, value: element.key }
                    data.key = element.key;
                    empresas.push(data);
                })
                setEmpresa(empresas);
            }
        }
        )();
    }, []);

    return empresa;
}

export default useEmpresa;


// WEBPACK FOOTER //
// ./src/Components/Hooks/useEmpresa.js